import * as React from 'react';
import { useState, useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Box, Button, Collapse } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from '../../assets/logo.png';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { RiDashboard3Line } from 'react-icons/ri';
import { TbSmartHome } from 'react-icons/tb';
import { AiOutlineAppstore } from 'react-icons/ai';
import { LuUserRound } from 'react-icons/lu';
import { PiTargetBold, PiUsers } from 'react-icons/pi';
import { FaRegFaceGrinStars } from 'react-icons/fa6';
import { SiMediamarkt } from 'react-icons/si';
import { useMediaQueries } from '../../usecontext/UseProvider';
import Loading from '../loading/Loading';

const menuItems = [
    { text: "Dashboard", icon: <RiDashboard3Line />, path: "/admin" },
    { text: "Home Carousal", icon: <TbSmartHome />, path: "/admin/home-carosal" },
    {
        text: "About",
        icon: <AiOutlineAppstore />,
        subItems: [
            { text: "Categories", path: "/admin/manage-store/categories" },
            { text: "Products", path: "/admin/manage-store/products" },
            { text: "Something Unique", path: "/admin/manage-store/unique" },
        ],
    },
    { text: "About Us", icon: <LuUserRound />, path: "/admin/aboutus" },
    { text: "Contact", icon: <PiUsers />, path: "/admin/contact" },
    { text: "Story and Purpose", icon: <PiTargetBold />, path: "/admin/story-perpose" },
    { text: "About Gallery", icon: <TbSmartHome />, path: "/admin/about-gallery" },
    { text: "Happy Customer", icon: <FaRegFaceGrinStars />, path: "/admin/happy-customer" },
    { text: "Media Manager", icon: <SiMediamarkt />, path: "/admin/media-manager" },
];


export default function Sidebar() {
    const [open, setOpen] = useState(false);
    const [openAbout, setOpenAbout] = useState(false);
    const [openServices, setOpenServices] = useState(false);
    const [openContact, setOpenContact] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { loading } = useMediaQueries();

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleClickAbout = () => {
        setOpenAbout(!openAbout);
        setOpenServices(false);
        setOpenContact(false);
    };

    const handleClickServices = () => {
        setOpenServices(!openServices);
        setOpenAbout(false);
        setOpenContact(false);
    };

    const handleClickContact = () => {
        setOpenContact(!openContact);
        setOpenAbout(false);
        setOpenServices(false);
    };

    useEffect(() => {
        handleDrawerClose();
    }, [pathname]);

    const handleOnLogOut = () => {
        navigate('/admin/login');
        localStorage.removeItem('userdata');
        localStorage.removeItem('token');
    };

    return (
        <div className="h-100">
            {isMobile ? (
                <>
                    <Box sx={{ display: 'flex', p: 2, justifyContent: 'space-between', position: 'sticky' }}>
                        <img src={logo} alt="Logo" style={{ height: '30px' }} />
                        <Button onClick={handleDrawerOpen}>
                            <MenuIcon />
                        </Button>
                    </Box>
                    <Drawer anchor="left" open={open} onClose={handleDrawerClose}>
                        <Box sx={{ width: '280px' }} role="presentation">
                            <Box sx={{ p: 4 }}>
                                <img src={logo} alt="Logo" className="w-100" />
                            </Box>
                            <List>
                                {menuItems.map((item) => (
                                    <React.Fragment key={item.text}>
                                        <ListItem
                                            sx={{ px: 1, py: 0 }}
                                            button
                                            onClick={item.subItems ? (item.text === 'About' ? handleClickAbout : item.text === 'Services' ? handleClickServices : handleClickContact) : undefined}
                                        >
                                            <ListItemButton
                                                component={Link}
                                                to={item.path}
                                                sx={{
                                                    color: pathname === item.path || (item.path !== '/admin' && pathname.startsWith(item.path)) ? '#01A0E2' : '#000',
                                                    borderRadius: '10px',
                                                    '&:hover': {
                                                        color: pathname === item.path || (item.path !== '/admin' && pathname.startsWith(item.path)) ? '#01A0E2' : '#000',
                                                        '& .MuiListItemIcon-root': {
                                                            color: pathname === item.path || (item.path !== '/admin' && pathname.startsWith(item.path)) ? '#01A0E2' : '#000',
                                                        },
                                                    },
                                                }}
                                            >
                                                <ListItemIcon sx={{
                                                    color: pathname === item.path || (item.path !== '/admin' && pathname.startsWith(item.path)) ? '#01A0E2' : '#000',
                                                    minWidth: '40px'
                                                }}>{item.icon}</ListItemIcon>
                                                <ListItemText
                                                    primary={item.text === 'About' ? 'Manage Store' : item.text}
                                                    sx={{
                                                        '.MuiTypography-root': {
                                                            color: pathname === item.path || (item.path !== '/admin' && pathname.startsWith(item.path)) ? '#01A0E2' : '#000',
                                                        }
                                                    }} />
                                                {item.subItems ?
                                                    (item.text === 'About' ?
                                                        (openAbout ? <ExpandLess /> :
                                                            <ExpandMore />) :
                                                        item.text === 'Services' ?
                                                            (openServices ? <ExpandLess /> : <ExpandMore />) :
                                                            openContact ? <ExpandLess /> : <ExpandMore />) :
                                                    null
                                                }
                                            </ListItemButton>
                                        </ListItem>
                                        {item.subItems && (
                                            <Collapse
                                                in={item.text === 'About' ? openAbout : item.text === 'Services' ? openServices : openContact}
                                                timeout="auto"
                                                unmountOnExit
                                            >
                                                <List component="div" disablePadding>
                                                    {item.subItems.map((subItem) => (
                                                        <ListItem key={subItem.text} sx={{ pl: 6, py: 0 }}>
                                                            <ListItemButton
                                                                component={Link}
                                                                to={subItem.path}
                                                                sx={{
                                                                    py: 0,
                                                                    color: pathname === subItem.path || (
                                                                        (pathname === '/admin/services/add' || pathname.match(/^\/admin\/services\/[a-zA-Z0-9]+$/) ||
                                                                            pathname === '/admin/contact-info/edit')
                                                                        && pathname.startsWith(subItem.path)
                                                                    )
                                                                        ? '#01A0E2' : '#000',
                                                                    borderRadius: '10px',
                                                                    '&:hover': {
                                                                        '& .MuiListItemIcon-root': {
                                                                            color: '#fff',
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                <ListItemText
                                                                    primary={subItem.text}
                                                                    sx={{
                                                                        '.MuiTypography-root': {
                                                                            color: pathname === subItem.path || (subItem.path !== '/admin' && pathname.startsWith(subItem.path)) ? '#01A0E2' : '#000',
                                                                        }
                                                                    }}
                                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                                />

                                                            </ListItemButton>
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Collapse>
                                        )}
                                    </React.Fragment>
                                ))}
                            </List>
                            <Box sx={{ pl: 6 }}>
                                <Button
                                    fullWidth
                                    sx={{
                                        mt: 2,
                                        color: '#000',
                                        textTransform: 'none',
                                        justifyContent: 'start'
                                    }}
                                    startIcon={<LogoutIcon />}
                                    onClick={handleOnLogOut}
                                >
                                    Logout
                                </Button>
                            </Box>
                        </Box>
                    </Drawer>
                </>
            ) : (
                <Drawer anchor="left" variant="permanent" open>
                    <Box sx={{ width: '240px' }} role="presentation">
                        <Box sx={{ px: 3, pt: 3, pb: 2 }}>
                            <img src={logo} alt="Logo" className="w-100" />
                        </Box>
                        <List>
                            {menuItems.map((item) => (
                                <React.Fragment key={item.text}>
                                    <ListItem sx={{ px: 2, py: '1px' }}
                                        button
                                        onClick={item.subItems ? (item.text === 'About' ? handleClickAbout : item.text === 'Services' ? handleClickServices : handleClickContact) : undefined}
                                    >
                                        <ListItemButton
                                            component={Link}
                                            to={item.path}
                                            sx={{
                                                py: 0.5,
                                                backgroundColor: pathname === item.path || (item.path !== '/admin' && pathname.startsWith(item.path)) ? '#01A0E2' : '',
                                                color: pathname === item.path || (pathname.startsWith(item.path) && item.path !== '/admin') ? '#fff' : '#000',
                                                borderRadius: '10px',
                                                '&:hover': {
                                                    backgroundColor: '#01A0E2',
                                                    color: '#fff',
                                                    '& .MuiListItemIcon-root': {
                                                        color: '#fff',
                                                    },
                                                    '.MuiTypography-root': {
                                                        color: '#fff'
                                                    }
                                                },
                                            }}

                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: '25px',
                                                    color: pathname === item.path || (item.path !== '/admin' && pathname.startsWith(item.path)) ? '#fff' : '#000'
                                                }}
                                            >
                                                {item.icon}
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={item.text === 'About' ? 'Manage Store' : item.text}
                                                sx={{
                                                    '.MuiTypography-root': {
                                                        color: pathname === item.path || (item.path !== '/admin' && pathname.startsWith(item.path)) ? '#fff' : '#000'
                                                    }
                                                }} />
                                            {item.subItems ?
                                                (item.text === 'About'
                                                    ? (openAbout ? <ExpandLess /> : <ExpandMore />) :
                                                    item.text === 'Services' ?
                                                        (openServices ? <ExpandLess /> : <ExpandMore />) :
                                                        openContact ? <ExpandLess /> : <ExpandMore />) :
                                                null
                                            }
                                        </ListItemButton>
                                    </ListItem>
                                    {item.subItems && (
                                        <Collapse
                                            in={item.text === 'About' ? openAbout : item.text === 'Services' ? openServices : openContact}
                                            timeout="auto"
                                            unmountOnExit
                                        >
                                            <List component="div" disablePadding>
                                                {item.subItems.map((subItem) => (
                                                    <ListItem key={subItem.text} sx={{ pl: 4, py: 0 }}>
                                                        <ListItemButton
                                                            component={Link}
                                                            to={subItem.path}
                                                            sx={{
                                                                color: pathname === subItem.path || (
                                                                    (pathname === '/admin/services/add' || pathname.match(/^\/admin\/services\/[a-zA-Z0-9]+$/) || pathname === '/admin/contact-info/edit')
                                                                    && pathname.startsWith(subItem.path)
                                                                )
                                                                    ? '#fff' : '#000',
                                                                borderRadius: '10px',
                                                                backgroundColor: pathname === subItem.path || (subItem.path !== '/admin' && pathname.startsWith(subItem.path)) ? '#01A0E2' : '#fff',
                                                                '&:hover': {
                                                                    backgroundColor: pathname === subItem.path || (subItem.path !== '/admin' && pathname.startsWith(subItem.path)) ? '#01A0E2' : '#fff',

                                                                    color: pathname === subItem.path || (
                                                                        (pathname === '/admin/services/add' || pathname.match(/^\/admin\/services\/[a-zA-Z0-9]+$/) || pathname === '/admin/contact-info/edit')
                                                                        && pathname.startsWith(subItem.path)
                                                                    )
                                                                        ? '#fff' : '#01A0E2',
                                                                    '& .MuiListItemIcon-root': {
                                                                        color: '#01A0E2',
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <ListItemText
                                                                primary={subItem.text}
                                                                sx={{
                                                                    '.MuiTypography-root': {
                                                                        color: pathname === subItem.path || (subItem.path !== '/admin' && pathname.startsWith(subItem.path)) ? '#fff' : '#000'
                                                                    }
                                                                }}
                                                            />
                                                        </ListItemButton>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Collapse>
                                    )}
                                </React.Fragment>
                            ))}
                        </List>
                        <Box sx={{ pl: '32px' }}>
                            <Button
                                fullWidth
                                sx={{
                                    mt: 2,
                                    color: '#000',
                                    textTransform: 'none',
                                    justifyContent: 'start'
                                }}
                                startIcon={<LogoutIcon />}
                                onClick={handleOnLogOut}
                            >
                                Logout
                            </Button>
                        </Box>
                    </Box>
                </Drawer>
            )}
            <Box
                sx={{
                    minHeight: '100vh',
                    px: isMobile ? 2 : 3,
                    marginLeft: isMobile ? 0 : '240px',
                    backgroundColor: '#F2F8FB'
                }}
            >
                <Outlet />
                {loading && <Loading />}
            </Box>
        </div>
    );
}